import React, {useState, useEffect} from 'react';
import {  Tree, Drawer, Table, Button, Popconfirm, Space, Input} from 'antd';
import { SearchOutlined } from "@ant-design/icons";
import {titleCase} from './GenFuncs';
import Highlighter from "react-highlight-words";
import StudentCoursesModal from './StudentCoursesModal';



export default function StudentCoursesTable (props) {;
  const [checkedKeys, setCheckedKeys] = useState([]);
  const [filtedCourseId, setFiltedCourseId] = useState([]);
  const [drawerVisible, setDrawerVisible] = useState(false);
  const [drawerTreeData, setDrawerTreeData] = useState([]);
  const [searchText, setSearchText] = useState('');
  const [searchedColumn, setSearchedColumn] = useState('');
  const [courseTableDataSource, setCourseTableDataSource] = useState([]);
  const [modalVisible, setModalVisible] = useState(false);
  const [modalRowRecord, setModalRowRecord] = useState(null);

  useEffect(() => {
    fetch(`https://kh-studentrecordsystem.herokuapp.com/studentsInfo/${props.id}/Courses`)
      .then(res => res.json())
      .then(data => setCourseTableDataSource(data))      
      .catch(err => console.log(err))
    setDrawerTreeData([]);
  },[props.id])

  const handleAddCourses = () => {
    fetch(`https://kh-studentrecordsystem.herokuapp.com/studentsInfo/${props.id}/drawer`)
      .then(response => response.json())
      .then(data => { 
        setDrawerTreeData(data);
        setDrawerVisible(true);
      })
      .catch(err => console.log(err))
  }

  const getColumnSearchProps = dataIndex => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
    <div style={{ padding: 8 }}>
        <Input
        ref={node => {
            this.searchInput = node;
        }}
        placeholder={titleCase(`Search ${dataIndex}`)}
        value={selectedKeys[0]}
        onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
        onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
        style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Space>
        <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
        >
            Search
        </Button>
        <Button onClick={() => handleReset(clearFilters)} size="small" style={{ width: 90 }}>
            Reset
        </Button>
        </Space>
    </div>
    ),
    filterIcon: filtered => <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />,
    onFilter: (value, record) =>
    record[dataIndex]
        ? record[dataIndex].toString().toLowerCase().includes(value.toLowerCase())
        : '',
    onFilterDropdownVisibleChange: visible => {
    if (visible) {
        setTimeout(() => this.searchInput.select(), 100);
    }
    },
    render: text =>
    searchedColumn === dataIndex ? (
        <Highlighter
        highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
        searchWords={searchText}
        autoEscape
        textToHighlight={text ? text.toString() : ''}
        />
    ) : (
        text
    ),
  });

const handleSearch = (selectedKeys, confirm, dataIndex) => {
  confirm();
  setSearchText(selectedKeys[0]);
  setSearchedColumn(dataIndex);
};

const handleReset = clearFilters => {
    clearFilters();
    setSearchText(``);
};

const coursesColumns = [
  {
    title: 'Grade',
    dataIndex: 'courseGrade',
    width: "5%",
    defaultSortOrder: 'ascend',
    sorter: (a, b) => {
      let gradeA = a.courseGrade.toUpperCase();
      let gradeB = b.courseGrade.toUpperCase();
      if (gradeA < gradeB) {
        return -1;
      } else if (gradeA > gradeB) {
        return 1;
      } else {
        return 0;
      }
    },
    sortDirections: ['descend', 'ascend'],
    ...getColumnSearchProps('courseGrade'),
  },
  {
    title: 'Semester',
    dataIndex: 'courseSemester',
    width: "5%",
    defaultSortOrder: 'ascend',
    sorter: (a, b) => {
      let semesterA = String(a.courseSemester).toUpperCase();
      let semesterB = String(b.courseSemester).toUpperCase();
      if (semesterA < semesterB) {
        return -1;
      } else if (semesterA > semesterB) {
        return 1;
      } else {
        return 0;
      }
    },
    sortDirections: ['descend', 'ascend'],
    ...getColumnSearchProps('courseSemester'),
  },
  {
    title: 'Course',
    dataIndex: 'course',
    width: "20%",
    ...getColumnSearchProps('courses'),
  },
  {
    title: 'Score',
    dataIndex: 'score',
    width: "20%",
  },
  {
    title: 'Operation',
    dataIndex: 'operation',
    width: "5%",
    render: (text, record) => ( 
      <Space size="middle">
        <Button type="text" onClick={() => {handleScoreEditBtn(record)}} className="opBtn" style={{color: "blue"}}>Edit</Button>
        <Popconfirm title="Sure to delete?" onConfirm={() => handleCourseDelete(record)}>
          <Button danger type="text">Delete</Button>
        </Popconfirm>
      </Space>
    )
  },     
]

//Done
const handleScoreEditBtn = (record) => {
  setModalRowRecord(record);
  setModalVisible(true);
}

//Done
const handleScoreUpdateBtn = (record) => {
  const newData = {
    _id: modalRowRecord._id,
    score: record.score,
  }
  fetch(`https://kh-studentrecordsystem.herokuapp.com/studentsInfo/${props.id}/Courses`, {
      method: 'PUT',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify(newData),
  })
    .then(data => {
      fetch(`https://kh-studentrecordsystem.herokuapp.com/studentsInfo/${props.id}/Courses`)
        .then(res => res.json())
        .then(data => {          
          setCourseTableDataSource(data);
          setModalVisible(false)
        })
    })
}

const handleCourseDelete = (record) => {
  fetch(`https://kh-studentrecordsystem.herokuapp.com/studentsInfo/${props.id}/Courses`, {
    method: 'DELETE',
    headers: {'Content-Type': 'application/json'},
    body: JSON.stringify(record),
  })
  .then(data => {
    fetch(`https://kh-studentrecordsystem.herokuapp.com/studentsInfo/${props.id}/Courses`)
      .then(res => res.json())
      .then(data => {
        setCourseTableDataSource(data);
      })
  })
}

//如果往后端传复杂类型的数据，如Array或Object，可以用POST去传
  const handleDrawerSubmit = () => {
    fetch(`https://kh-studentrecordsystem.herokuapp.com/studentsInfo/${props.id}/Courses`, {
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify(filtedCourseId),
    })
      .then(data => {        
        fetch(`https://kh-studentrecordsystem.herokuapp.com/studentsInfo/${props.id}/Courses`)
          .then(response => response.json())
          .then(data => {
            setCourseTableDataSource(data);
            setDrawerVisible(false);  
            setCheckedKeys([]);          
          })   
          .catch(err => console.log(err))    
      })
      .catch(err => console.log(err))
  }

  const onCheck = (checkedKeys, e) => {
    setCheckedKeys(checkedKeys);
    let checkedId = [];
    if (checkedKeys.length > 0) {
      let restructedArr = e.checkedNodes.filter(x => x.courseId !== undefined)
      for (let i = 0; i < restructedArr.length; i++) {
        checkedId.push(restructedArr[i].courseId)
      }
    }
    setFiltedCourseId(checkedId);
  }

  return (
    <div>
      <Button onClick={handleAddCourses} type="primary" className="pageMainFuncBtn" style={{marginTop: "50px"}}>Add Courses</Button>

      <Table
        rowKey={record => record._id}
        bordered
        dataSource={courseTableDataSource}
        columns={coursesColumns}
        pagination={{defaultPageSize: 20}}
        title={() => {return (
          <div className="studentTableHead">
            Courses Detail
          </div>
        )}}
      />

      <StudentCoursesModal
        visible={modalVisible}
        record={modalRowRecord}
        onCancel={() => {
          setModalRowRecord(null)
          setModalVisible(false);
        }}
        onUpdate={handleScoreUpdateBtn}
      />

      <Drawer
        title={<div className="drawerTitle">Courses</div>}
        placement="right"
        closable
        onClose={()=>{setDrawerTreeData([]);setDrawerVisible(false);setCheckedKeys([])}}
        visible={drawerVisible}
        width="388px"
        footer={
          <div style={{textAlign: "right"}}>
            <Button type="primary" onClick={handleDrawerSubmit}>Submit</Button>
            <Button onClick={()=>{setDrawerVisible(false);setCheckedKeys([]);}}>Cancel</Button>                
          </div>
        }
      >
        <Tree
          checkable
          onCheck={onCheck}
          checkedKeys={checkedKeys}
          treeData={drawerTreeData}
        />
      </Drawer>
    </div>
  );
};